
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Puneto3jyotilingatorspackages() {



    const cardData =
    {
        keyword: 'Pune To 3 Jyotirlinga Tour Package',
        heading: 'Morya Cabs: Pune To 3 Jyotirlinga Tour Package',
        headingDescription: 'Morya Cabs offers a well-planned Pune to 3 Jyotirlinga Tour Package, providing a comfortable and divine pilgrimage experience. This package covers the sacred temples of Bhimashankar, Trimbakeshwar, and Grishneshwar, ensuring a smooth journey for all travelers. Whether you are traveling with family, elders, or a spiritual group, our clean, spacious, and well-maintained cabs, along with experienced and courteous drivers, guarantee a safe and hassle-free journey.',

        top: 'Top Places to Visit in 3 Jyotirlinga with Morya Cabs',

"topPlaces": [
    {
        "title": "Bhimashankar Jyotirlinga",
        "description": "Located about 110 km (3–4 hrs drive) from Pune in the Sahyadri hills, Bhimashankar is both a revered Jyotirlinga and a lush wildlife sanctuary. The temple sits in a dense forest, near the origin of the Bhima River. Pilgrims can combine spiritual darshan with nature walks and waterfall visits—especially stunning in the monsoon season when greenery and mist create magical scenery."
    },
    {
        "title": "Trimbakeshwar Jyotirlinga",
        "description": "About 240 km from Pune (near Nashik), this sacred site features a unique three‑faced Shiva Linga representing Brahma, Vishnu, and Shiva. Nestled at the foot of Brahmagiri Hill—the source of the Godavari River—the temple offers powerful spiritual energy and traditional abhishekam rituals. Nearby, pilgrims can visit Kushavarta Kund for holy dips and explore Brahmagiri Hill’s scenic trails."
    },
    {
        "title": "Grishneshwar Jyotirlinga",
        "description": "Roughly 260 km northeast of Pune (near Aurangabad and Ellora Caves), Grishneshwar is the smallest yet deeply revered Jyotirlinga. Built in intricate Hemadpanthi architectural style, it's linked to the legend of a devoted woman named Kusuma whose unwavering faith invoked Shiva. Pilgrims often combine this darshan with a visit to the UNESCO‑listed Ellora Caves nearby."
    }
],

  "services": [
    {
      "name": "Pune to 3 Jyotirlinga Tour Package",
      "description": "Morya Cab offers a well-organized Pune to 3 Jyotirlinga tour package covering Bhimashankar, Trimbakeshwar, and Grishneshwar temples. Enjoy a spiritual journey with comfortable rides, expert drivers, and flexible itineraries designed for a fulfilling pilgrimage."
    },
    {
      "name": "Cab Tour for 3 Jyotirlingas from Pune",
      "description": "Experience the divine with Morya Cab’s dedicated cab tour for the 3 Jyotirlingas from Pune. Our reliable service ensures smooth travel between temples with ample time for darshan and sightseeing."
    },
    {
      "name": "Pune to Bhimashankar Trimbakeshwar Grishneshwar Cab",
      "description": "Travel conveniently to the sacred Bhimashankar, Trimbakeshwar, and Grishneshwar temples with Morya Cab. Our vehicles are well-maintained and drivers experienced in the pilgrimage routes, ensuring a safe and pleasant journey."
    },
    {
      "name": "Religious Jyotirlinga Tour Pune",
      "description": "Plan your religious Jyotirlinga tour from Pune with Morya Cab, offering dedicated services that respect your spiritual needs, with comfort, safety, and timely temple visits."
    },
    {
      "name": "AC Cabs for Jyotirlinga Darshan from Pune",
      "description": "Beat the heat and travel comfortably with Morya Cab’s air-conditioned taxis for your Jyotirlinga darshan tour. Enjoy a refreshing ride during your pilgrimage to the holy shrines."
    },
    {
      "name": "Long-Distance Pilgrimage Tour Cab Pune",
      "description": "Our long-distance pilgrimage tour cabs from Pune are designed for comfort and convenience on extended journeys. Travel with confidence and ease across multiple temples with Morya Cab."
    },
    {
      "name": "Online Booking 3 Jyotirlinga Cab Tour",
      "description": "Book your Pune to 3 Jyotirlinga cab tour easily online with Morya Cab. Get instant booking confirmation and flexible payment options for a hassle-free pilgrimage planning."
    },
    {
      "name": "Pune to 3 Temples Jyotirlinga Taxi",
      "description": "Morya Cab provides dedicated taxi services from Pune covering all three Jyotirlinga temples. Enjoy a personalized and safe taxi experience with courteous drivers familiar with the religious routes."
    },
    {
      "name": "Sedan Cabs for Jyotirlinga Tour Pune",
      "description": "Choose from our fleet of comfortable sedans for your Jyotirlinga tour from Pune. Morya Cab offers spacious and clean vehicles suitable for families or small groups on their pilgrimage."
    },
    {
      "name": "Multi-Day Cab Tour Package Pune",
      "description": "Opt for a multi-day cab tour package for the Jyotirlinga pilgrimage with Morya Cab, allowing you to explore the temples at a relaxed pace with comfortable overnight travel arrangements."
    },
    {
      "name": "Jyotirlinga Trip Cab with Driver Pune",
      "description": "Travel with professional drivers who are experienced and knowledgeable about the Jyotirlinga temple timings and routes. Morya Cab ensures your trip is safe, timely, and comfortable."
    },
    {
      "name": "Safe Temple Tour Cabs Pune",
      "description": "Safety is a priority for Morya Cab during your temple tours. Vehicles are sanitized regularly, and drivers follow all safety protocols to provide a secure pilgrimage experience from Pune."
    },
    {
      "name": "Affordable Jyotirlinga Tour from Pune",
      "description": "Enjoy affordable and transparent pricing for your Jyotirlinga tour cab services from Pune. Morya Cab offers competitive rates without hidden charges, perfect for budget-conscious travelers."
    },
    {
      "name": "Verified Cab for Religious Tours Pune",
      "description": "All Morya Cab vehicles and drivers are verified and trusted, ensuring a reliable and quality religious tour experience for pilgrims traveling from Pune."
    },
    {
      "name": "Pune Outstation Jyotirlinga Cab",
      "description": "For outstation travel to Jyotirlinga temples from Pune, Morya Cab provides dedicated outstation cabs with flexible schedules, well-maintained vehicles, and courteous drivers to make your journey smooth and enjoyable."
    }
  ],
  "tableData": [
    ["Pune to 3 Jyotirlinga Tour Package", "-Cab Tour for 3 Jyotirlingas from Pune"],
    ["Pune to Bhimashankar Trimbakeshwar Grishneshwar Cab", "-Religious Jyotirlinga Tour Pune"],
    ["AC Cabs for Jyotirlinga Darshan from Pune", "-Long-Distance Pilgrimage Tour Cab Pune"],
    ["Online Booking 3 Jyotirlinga Cab Tour", "-Pune to 3 Temples Jyotirlinga Taxi"],
    ["Sedan Cabs for Jyotirlinga Tour Pune", "-Multi-Day Cab Tour Package Pune"],
    ["Jyotirlinga Trip Cab with Driver Pune", "-Safe Temple Tour Cabs Pune"],
    ["Affordable Jyotirlinga Tour from Pune", "-Verified Cab for Religious Tours Pune"],
    ["Pune Outstation Jyotirlinga Cab", "-Call Morya Cab at +91 9371304510"]
  ],




whychoose: [
    {
        "WhyChooseheading": "Devotion-Focused and Reliable Tour Planning",
        "WhyChoosedescription": "Morya Cab understands the spiritual importance of the Jyotirlinga Darshan Yatra. Our Pune to 3 Jyotirlinga Tour Package (Bhimashankar, Trimbakeshwar, and Grishneshwar) is designed to help you complete this sacred pilgrimage in a smooth, timely, and peaceful manner. We ensure each leg of your journey is precisely planned—covering temple timings, routes, and rest halts—so you can focus on your prayers while we manage the logistics with complete reliability."
    },
    {
        "WhyChooseheading": "Comfortable and Long-Trip Friendly Vehicles",
        "WhyChoosedescription": "This multi-day Jyotirlinga Yatra involves long drives across hilly and rural terrains, which is why we provide well-maintained, spacious vehicles built for comfort. All our cabs come with AC, ample legroom, reclining seats, and smooth suspension. Whether you're a solo devotee, senior pilgrim, or traveling with your family, we have sedan, SUV, and tempo traveller options to match your group size and travel needs."
    },
    {
        "WhyChooseheading": "Experienced and Devout Drivers",
        "WhyChoosedescription": "Our drivers are specially trained for religious tour routes and have extensive experience covering the Bhimashankar–Trimbakeshwar–Grishneshwar circuit. They are courteous, punctual, and familiar with temple opening hours, darshan timings, and ideal breakpoints. With their help, you’ll save time, avoid crowded hours, and receive respectful assistance throughout your pilgrimage journey—making it comfortable and spiritually enriching."
    },
    {
        "WhyChooseheading": "Affordable, Transparent, and All-Inclusive Packages",
        "WhyChoosedescription": "Morya Cab offers well-structured, budget-friendly pricing for our 3 Jyotirlinga Tour Package. Our rates include fuel, tolls, parking, and driver allowance—so there are no hidden costs or last-minute surprises. Whether you choose a 2-day or 3-day itinerary with or without accommodation, you’ll get full clarity on inclusions, and we’ll help you choose the best package that fits your schedule and budget."
    },
    {
        "WhyChooseheading": "Safe and Peaceful Pilgrimage Experience",
        "WhyChoosedescription": "Safety is crucial when you're traveling across varied terrains and long distances. Our cabs are GPS-tracked, sanitized, and undergo regular servicing. They are also equipped with safety features like seat belts, airbags, and ABS brakes. With disciplined and responsible drivers, you can relax and immerse yourself in devotion while we ensure you reach each Jyotirlinga safely and peacefully."
    },
    {
        "WhyChooseheading": "24/7 Support During Your Pilgrimage",
        "WhyChoosedescription": "Our dedicated support team is available 24/7 to guide you before and during the journey. Whether you need help with itinerary adjustments, darshan queries, or emergency travel changes, we’re just a call away. Especially on religious tours where time and comfort matter most, our round-the-clock assistance gives you complete peace of mind throughout the Yatra."
    },
    {
        "WhyChooseheading": "Seamless Booking with Customizable Itineraries",
        "WhyChoosedescription": "Booking your Pune to 3 Jyotirlinga Tour Package is easy via our website or mobile app. Choose your preferred travel dates, duration, and pickup points. Want to add an extra temple visit like Shirdi, or include hotel bookings? We provide complete customization and quick booking confirmation. From the moment you book to your final drop-off, the process is simple, smooth, and spiritually fulfilling."
    },
    {
        "WhyChooseheading": "Tailored Pilgrimage Packages for Every Devotee",
        "WhyChoosedescription": "We understand that every pilgrim has different needs. Whether you're traveling with senior citizens, prefer early morning darshans, want temple stay options, or plan to explore nearby destinations like Ellora Caves or Nashik, Morya Cab will personalize your Jyotirlinga tour. Our flexible and custom travel plans ensure a meaningful journey aligned with your devotion, comfort, and pace."
    }
]













    }

const faqData = [
  {
    question: "How can I book the Pune to 3 Jyotirlinga tour package with Morya Cab?",
    answer: "You can book the tour through our website, mobile app, or by calling our support team for personalized assistance and itinerary planning."
  },
  {
    question: "Which Jyotirlingas are covered in the 3 Jyotirlinga tour from Pune?",
    answer: "Our tour covers Bhimashankar, Trimbakeshwar (Nashik), and Grishneshwar (near Ellora). The route is planned efficiently for a smooth experience."
  },
  {
    question: "How many days does the 3 Jyotirlinga tour take?",
    answer: "The tour typically takes 2 to 3 days depending on your pace, darshan time, and overnight stays. We also offer customizable schedules."
  },
  {
    question: "What types of vehicles are available for this trip?",
    answer: "We provide a range of comfortable, air-conditioned vehicles including sedans, SUVs, and tempo travelers for individuals, families, or groups."
  },
  {
    question: "Are the drivers familiar with temple timings and routes?",
    answer: "Yes, our drivers are highly experienced with these spiritual routes and will guide you on the best times for darshan and travel."
  },
  {
    question: "Does the package include accommodation and meals?",
    answer: "Accommodation and meals are optional. We can suggest trusted hotel options if needed, or you can arrange them independently while we handle the travel."
  },
  {
    question: "Can I customize the trip and add other religious stops?",
    answer: "Absolutely! The itinerary is flexible. You can add other temples or sightseeing spots—just inform us during booking."
  },
  {
    question: "What are the payment options for this package?",
    answer: "We accept online payments, UPI, credit/debit cards, net banking, and cash. A partial advance may be required to confirm your booking."
  },
  {
    question: "Is this tour suitable for elderly or special needs passengers?",
    answer: "Yes, our cabs are very comfortable, and we ensure proper care for senior citizens or anyone needing extra assistance."
  },
  {
    question: "Why choose Morya Cab for the Pune to Jyotirlinga tour?",
    answer: "Morya Cab offers reliable, punctual, and comfortable cab services with experienced drivers and flexible tour options for a divine and hassle-free experience."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Prakash Shinde',
    role: 'Pilgrimage Organizer',
    review: 'I booked Morya Cab for our 3 Jyotirlinga trip. Everything from timing to temple guidance was handled professionally. Highly recommended for spiritual tours!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Mrs. Vaishali Patankar',
    role: 'Senior Citizen',
    review: 'We visited Bhimashankar, Trimbakeshwar, and Grishneshwar comfortably in 3 days. The driver was extremely helpful and respectful throughout. Great service by Morya Cab!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];







      
      
      
      
      
            
            
            
      











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


   
const puneToJyotirlingaTourSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to 3 Jyotirlinga Tour Package",
  "image": "https://moryacab.com/assets/images/pune-3-jyotirlinga-tour.jpg",
  "description": "Book an affordable Pune to 3 Jyotirlinga Tour Package with AC cabs, sedans & SUVs. Cover Bhimashankar, Trimbakeshwar & Grishneshwar temples. Safe, comfortable, and customized trips with verified drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Morya Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "12456",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7499",
    "availability": "https://schema.org/InStock",
    "url": "https://moryacab.com/pune-to-3-jyotirlinga-tour-package"
  }
};









      

    return (
        <div>

<UsePageTracking/>
<Helmet>
  <title>Pune to 3 Jyotirlinga Tour Package | Bhimashankar, Trimbakeshwar, Grishneshwar | Morya Cabs</title>
  <meta
    name="description"
    content="Book an affordable Pune to 3 Jyotirlinga Tour Package with AC cabs, sedans & SUVs. Cover Bhimashankar, Trimbakeshwar & Grishneshwar temples. Safe, comfortable, and customized trips with verified drivers."
  />
  <meta
    name="keywords"
    content="Pune to 3 Jyotirlinga Tour, Jyotirlinga Tour Package from Pune, Bhimashankar Trimbakeshwar Grishneshwar Tour, Pune to Jyotirlinga Cab, Jyotirlinga Temple Tour from Pune, AC Cab Pune to Jyotirlinga, Sedan SUV Cab Jyotirlinga Tour, Morya Cabs Jyotirlinga Tour, One Day Jyotirlinga Tour Pune, Pilgrimage Cab Pune Jyotirlinga, Pune Darshan Jyotirlinga, Jyotirlinga Tour Package Car Booking"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToJyotirlingaTourSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/103.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Puneto3jyotilingatorspackages;